<template>
  <div class="row mb-4">
    <div class="col-md-2">
      <select v-model="limit" class="form-select">
        <option>10</option>
        <option>25</option>
        <option>50</option>
      </select>
    </div>
    <div class="col-md-4 ms-auto">
      <div class="input-group">
        <input
          v-model="searchTerm"
          type="text"
          class="form-control"
          placeholder="Search all users.."
        />
        <span class="input-group-text bg-body border-0">
          <i class="fa fa-search"></i>
        </span>
      </div>
    </div>
  </div>

  <datatable
    :url="ajaxUrl"
    :limit="limit"
    :order-by="orderBy"
    :order-asc="orderAsc"
    :search="searchTerm"
  >
    <template #headings>
      <sortableTh
        :current-order-by="orderBy"
        :order-asc="orderAsc"
        order-by="name"
        @set-order-by="setOrder"
      >
        Name
      </sortableTh>
      <sortableTh
        :current-order-by="orderBy"
        :order-asc="orderAsc"
        order-by="email"
        @set-order-by="setOrder"
      >
        Email
      </sortableTh>
      <sortableTh
        :current-order-by="orderBy"
        :order-asc="orderAsc"
        order-by="created_at"
        @set-order-by="setOrder"
      >
        Created at
      </sortableTh>
      <th></th>
    </template>
    <template #rows="{ data }">
      <tr v-for="user in data" :key="user.id">
        <td>{{ user.name }}</td>
        <td>{{ user.email }}</td>
        <td>{{ user.created_at }}</td>
        <td v-html="user.actions"></td>
      </tr>
    </template>
  </datatable>
</template>

<script setup>
import { ref } from "vue";
import datatable from "@/components/datatable.vue";
import sortableTh from "@/components/datatable/sortableTh.vue";

const props = defineProps({
  ajaxUrl: {
    type: String,
    required: true,
  },
});

const orderBy = ref("name");
const orderAsc = ref(true);
const limit = ref(10);
const searchTerm = ref(null);

const setOrder = function (input) {
  if (orderBy.value === input) {
    orderAsc.value = !orderAsc.value;
  } else {
    orderBy.value = input;
    orderAsc.value = true;
  }
};
</script>
